import { render } from "./DemosForm.vue?vue&type=template&id=196f4888"
import script from "./DemosForm.vue?vue&type=script&lang=js"
export * from "./DemosForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__